import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "app-footer" };
const _hoisted_2 = { class: "footer-content" };
const _hoisted_3 = { class: "footer-text" };
import { useI18n } from '../../composables/useI18n';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppFooter',
    setup(__props) {
        const { t } = useI18n();
        const currentYear = computed(() => {
            return new Date().getFullYear();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t).studio.name) + " © " + _toDisplayString(currentYear.value), 1)
                ])
            ]));
        };
    }
});
